import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as storage from 'reporting-data/lib/storage';
import { SMART_LIBRARY_PATHS } from '../types/navigation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PREVIOUS_PATH_STORAGE_KEY } from '../constants/navigation';
import { Button } from 'foundations-components/transitional/components/Button';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewerBreadcrumbs = () => {
  const history = useHistory();
  const handleCloseViewer = useCallback(() => {
    const previousPath = storage.get(PREVIOUS_PATH_STORAGE_KEY);
    if (previousPath) {
      history.push(previousPath);
    } else {
      history.push(SMART_LIBRARY_PATHS.USER_LIBRARY);
    }
  }, [history]);
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    children: /*#__PURE__*/_jsx(Button, {
      onClick: handleCloseViewer,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartLibrary.savedAssets.back"
      })
    })
  });
};